import React, { useEffect } from "react";
import { Location } from "history";
import { withRouter, RouteComponentProps } from "react-router-dom";
import { IntlShape, useIntl } from "react-intl";

import { setTitle } from "@app/util";
import { messages } from "@app/messages";
import { messages as sMessages } from "@search/messages";
import { getQuery } from "@search/selectors";
import { SearchResults } from "@search/components/SearchResults";
import { Page, CardBody } from "@ui/Page";

type Props = RouteComponentProps<any>;

const setSearchTitle = (intl: IntlShape, location: Location) => {
    let title = "";
    const q = getQuery(location.search);
    if (q) {
        title = intl.formatMessage(sMessages.searchResultsTitle, {
            query: q,
        });
    }
    else {
        title = intl.formatMessage(messages.pageSearchTitle);
    }
    setTitle(intl, title);
};

const SearchPage = ({ location }: Props) => {
    const intl = useIntl();
    useEffect(() => {
        setSearchTitle(intl, location);
    }, [location.search]);
    const q = getQuery(location.search);
    return (
        <Page className="search-page">
            <SearchResults query={q ? q : ""} />
        </Page>
    );
};

const ConnectedSearchPage = withRouter(SearchPage);

export {
    SearchPage as SearchPagePresenter,
    ConnectedSearchPage as SearchPage,
};
